const DEFAULT_ARROW_COLOR = "#6E7079";

export const SingleArrow = ({
  color = DEFAULT_ARROW_COLOR
}: {
  color?: string;
}) => (
  <svg
    width="24"
    height="10"
    viewBox="0 0 24 10"
    fill="none"
    className="shrink-0 mx-2"
  >
    <line x1="0" y1="5" x2="20" y2="5" stroke={color} strokeWidth="1.5" />
    <polyline
      points="16,2 20,5 16,8"
      stroke={color}
      strokeWidth="1.5"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BranchConnector = ({
  count,
  colors,
  stemColor = DEFAULT_ARROW_COLOR
}: {
  count: number;
  colors?: string[];
  stemColor?: string;
}) => {
  const rowH = 28;
  const totalH = count * rowH;
  const midPoints = Array.from(
    { length: count },
    (_, i) => i * rowH + rowH / 2
  );
  const branchColor = (i: number) => colors?.[i] ?? DEFAULT_ARROW_COLOR;
  return (
    <svg
      width="24"
      height={totalH}
      viewBox={`0 0 24 ${totalH}`}
      fill="none"
      className="shrink-0"
    >
      {midPoints.slice(0, -1).map((y, i) => (
        <line
          key={`stem-${i}`}
          x1="4"
          y1={y}
          x2="4"
          y2={midPoints[i + 1]}
          stroke={colors?.[i + 1] ?? stemColor}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      ))}
      {midPoints.map((y, i) => (
        <g key={y}>
          <line
            x1="3.25"
            y1={y}
            x2="19"
            y2={y}
            stroke={branchColor(i)}
            strokeWidth="1.5"
          />
          <polyline
            points={`15,${y - 3} 19,${y} 15,${y + 3}`}
            stroke={branchColor(i)}
            strokeWidth="1.5"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      ))}
    </svg>
  );
};
